import { Header,Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow,Dropdown,Form,Button,Loader,Icon, DropdownItemProps, Input } from 'semantic-ui-react'
import {useStore} from '../../../app/stores/store';
import { monthlyProductivitydata,ProductivityReportbyTitleBreakUp } from '../../../app/models/Restoration';
import {useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import agent from '../../../app/api/agent';

function MonthlyProductivityReport() {
    const [loadData, setLoadData] = useState<monthlyProductivitydata[]>([]);
    const [loadProjectData, setLoadProjectData] = useState<ProductivityReportbyTitleBreakUp[]>([]);
    const [year, setyear] = useState<string>('');
    const [month, setmonth] = useState<string>('');
    const [employeeId, setEmployeeId] = useState<string>('');
    const [years, setYears] = useState<DropdownItemProps[]>([]);
    const [loading,setLoading]=useState<boolean>(false);
    const [showDetailsReport,setShowDetailsReport]=useState<boolean>(false);
    const [reportType, setReportType] = useState<string>('');
    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');
    const { RestorationStore } = useStore();
    const [isLoading, setIsLoading] = useState(false);
    const [userOptions, setUserOptions] = useState<DropdownItemProps[]>([]);
    const [userRawData, setUserRawData] = useState<any[]>([]);

    useEffect(() => {
      const currentYear = new Date().getFullYear();
      setYears([
        { key: currentYear - 1, value: currentYear - 1, text: (currentYear - 1).toString() },
        { key: currentYear, value: currentYear, text: currentYear.toString() },
        { key: currentYear + 1, value: currentYear + 1, text: (currentYear + 1).toString() },
      ]);
    }, []);

    useEffect(() => {
      setFromDate('');
      setToDate('');
      setEmployeeId('');
      setmonth('');
      setyear('');
    }, [reportType]);

     useEffect(() => {
        fetchUsers();
      }, []);
    

    const dateBasedApiCall = async ()=> {
        try {
            await RestorationStore.monthlyProductivity(month,year,employeeId);
            setLoadData(RestorationStore.monthlyProductivitydata);
            setLoading(false);
            } 
        catch (error) { toast.error('Error fetching data');}
    };

    const ReportbyTitleBreakUp=async()=>{
      try {
          await RestorationStore.ProductivityReportbyTitleBreakUpAPICall(month,year,employeeId);
          setLoadProjectData(RestorationStore.ProductivityReportbyTitleBreakDetails)
          setLoading(false);
        }
      catch (error) {toast.error('Error fetching data');
    }};


    const reportTypeOptions = [
      { key: 'monthly', text: 'Monthly-wise', value: 'monthly' },
      { key: 'datewise', text: 'Date-wise', value: 'datewise' },
    ];

    const ListOfMonth = [
      { key: 1, text: 'January', value: 'January' },
      { key: 2, text: 'February', value: 'February' },
      { key: 3, text: 'March', value: 'March'},
      { key: 4, text: 'April', value: 'April' },
      { key: 5, text: 'May', value: 'May' },
      { key: 6, text: 'June', value: 'June' },
      { key: 7, text: 'July', value: 'July' },
      { key: 8, text: 'August', value: 'August' },
      { key: 9, text: 'September', value: 'September' },
      { key: 10, text: 'October', value: 'October' },
      { key: 11, text: 'November', value: 'November' },
      { key: 12, text: 'December', value: 'December' },
    ]

    const handleMonthChange = (event:any, data:any) => {
      setmonth(data.value);
    };
    const handleYearChange = (event:any, data:any) => { 
      setyear(data.value);
    };
    const handleEmployeeIdChange = (event:any, data:any) => { 
      setEmployeeId(data.value);
    };
  const dataLoad = () => {
    if (!reportType) return toast.error('Please select a Report Type.');

    setLoading(true);

    if (reportType === 'monthly') {
      if (!year) return toast.error('Please select a year.');
      if (!month) return toast.error('Please select a month.');
      showDetailsReport ? ReportbyTitleBreakUp() : dateBasedApiCall();
    } else {
      if (!fromDate || !toDate) return toast.error('Please select both From and To dates.');
      if (new Date(fromDate) > new Date(toDate))
        return toast.error('From date cannot be after To date.');

      showDetailsReport
        ? RestorationStore.ProductivityReportbyTitleBreakUpAPICallByDate(fromDate, toDate,employeeId)
            .then(() => {
              setLoadProjectData(RestorationStore.ProductivityReportbyTitleBreakDetails);
              setLoading(false);
            })
            .catch(() => toast.error('Error fetching data'))
        : RestorationStore.monthlyProductivityByDate(fromDate, toDate,employeeId)
            .then(() => {
              setLoadData(RestorationStore.monthlyProductivitydata);
              setLoading(false);
            })
            .catch(() => toast.error('Error fetching data'));
    }
  };

    const CsvConvert=()=>{
      const rows=[];
      const titleCodeRow=[
        'Emp ID',
        'Emp Name',
        'Designation',
        'Team',
        'Cluster Lead',
        'Sum of Frames',
        'Sum of Act Target',
        'Sum of Reject Frame',
        'Artifacts Rejected Frames',
        'Productivity',
        'Quality Percentage',
        'Artifacts Rejected Frames Percentage',
        'Working Days',
        'Present Days',
        'Leaves',
        'Attendance Percentage',
        'Tenure',
        'Months',
        'Efficency',
        'Attendance Hours',
        'HCHours',
        'HC Adherence',
        'Score card',      
        'Rank',
        'Points',
      ];
      const DetailedReportRow=[
          'Employee Id',
          'Employee Name',
          'Project Name',
          'Approval Frames',
          'Actual Hours',
          'Efficiency Hours',
          'Date Of Floor',
          'Current',
          'Tenure',
          'Efficency',
          'Estimate Hour',
          'Total Frames',
          'Target',
          'Actual Target',
          'Productivity %',
          'Rejected Frames',
          'Quality %',
          'Artifacts Frames',
          'Artifacts %',
      ];
      if(showDetailsReport)
      {
        rows.push(DetailedReportRow.join(','));
        loadProjectData.forEach((Manageritems:any)=>{
            const values = [
              Manageritems.employee_Id,
              Manageritems.employee_Name,
              Manageritems.project_Name,
              Manageritems.approval_Frames,
              Manageritems.total_Hours,
              Manageritems.efficiency_Hours,
              Manageritems.dof,
              Manageritems.current,
              Manageritems.tenure,
              Manageritems.efficency,
              Manageritems.est_Hour,
              Manageritems.total_Framess,
              Manageritems.target,
              Manageritems.actualTarget,
              Manageritems.productivity_percentage,
              Manageritems.sum_of_Rejected_Frames,
              Manageritems.quality_percentage,
              Manageritems.artifacts_Rejected_Frames,
              Manageritems.artifacts_Rejection_percentage,
            ];
            rows.push(values.join(','));
        });
      }
      else
      {
      rows.push(titleCodeRow.join(','));
      loadData.forEach(item => {
          const values = Object.values(item);
          rows.push(values.join(','));
      });
      }
      const csvContent = rows.join('\n');
      return csvContent;
    }

    const handleDownload = () => {
      const csvContent = CsvConvert();
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      if(showDetailsReport)
        {
          link.setAttribute('download', `${month}_${year}_ProductivityReportByProjectName.csv`);
        }
        else {
          link.setAttribute('download', `${month}_${year}_ProductivityReport.csv`);
        }
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const fetchUsers = async () => {
    try {
      const getRestorationUsers = (users: any) =>
        users.filter(
          (u: any) => u.departmentName?.trim().toLowerCase() === 'restoration',
        );

      setIsLoading(true);
      const users = await agent.Account.list();
      const filterData = getRestorationUsers(users);
      setUserRawData(filterData);
      setUserOptions(
        filterData.map((u: any) => ({
          key: u.id,
          text: u.displayName,
          value: u.displayName,
        })),
      );
    } catch (error) {
      console.error('Error fetching users:', error);
      toast.error('Failed to load users');
    } finally {
      setIsLoading(false);
    }
  };

    return (
      <>
      <div className="title-wise-table" >
        <div style={{ display: 'flex', alignItems: 'center' }}> <Header> Monthly Productivity Report</Header><br/>
        </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Field>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ paddingLeft: '20px' }}>
                  <h4>Report Type:</h4>
                </div>
                <div style={{ paddingLeft: '20px' }}>
                  <Dropdown
                    placeholder='Select Type'
                    selection
                    clearable
                    options={reportTypeOptions}
                    onChange={(e, data) => setReportType(data.value as string)}
                    value={reportType}
                  />
                </div>

                {reportType === 'monthly' && (
                  <>
                    <div style={{ paddingLeft: '20px' }}>
                      <h4>Year:</h4>
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                      <Dropdown
                        placeholder='Year'
                        search
                        selection
                        options={years}
                        onChange={handleYearChange}
                        value={year}
                      />
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                      <h4>Month:</h4>
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                      <Dropdown
                        placeholder='Month'
                        search
                        selection
                        options={ListOfMonth}
                        onChange={handleMonthChange}
                        value={month}
                      />
                    </div>
                  </>
                )}

                {reportType === 'datewise' && (
                  <>
                    <div style={{ paddingLeft: '20px' }}>
                      <h4>From:</h4>
                    </div>
                    <div style={{ paddingLeft: '10px' }}>
                      <Input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                      <h4>To:</h4>
                    </div>
                    <div style={{ paddingLeft: '10px' }}>
                      <Input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </>
                )}
                {(reportType === 'monthly'||  reportType === 'datewise') && (
                  <>
                    <div style={{ paddingLeft: '20px' }}>
                      <h4>EmployeeId:</h4>
                    </div>
                    <div style={{ paddingLeft: '20px' }}>
                      <Dropdown
                        placeholder='Select Users'
                        options={userOptions}
                        value={employeeId}
                        search
                        selection
                        clearable
                        onChange={handleEmployeeIdChange}
                        loading={isLoading}                       
                      />
                    </div>
                  </>
                )}
              </div>
            </Form.Field>
            {((year && month) || (fromDate && toDate)) && ( 
            <>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                <Form.Field>
                      <div className="ui checked checkbox" >
                      <input type="checkbox" onClick={()=>setShowDetailsReport(!showDetailsReport)} checked={showDetailsReport}/>
                      <label>Show Project Wise Details</label>
                      </div> 
                </Form.Field>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                      <Button primary onClick={dataLoad}>View Report</Button>
              </div>
              </>
              )}
            <Form.Field>
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                      {(loadData.length !== 0 || loadProjectData.length !== 0 ) && (<Button onClick={handleDownload}><Icon className='download'/></Button>)}
                      </div>
            </Form.Field>
          </div>
          <br/>
          <div style={{maxHeight: '80vh', overflowY: 'auto' }}>
          {showDetailsReport ? 
          <div>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Employee Id</TableHeaderCell>
                  <TableHeaderCell>Employee Name</TableHeaderCell>
                  <TableHeaderCell>Project Name</TableHeaderCell>
                  <TableHeaderCell>Approval Frames</TableHeaderCell>
                  <TableHeaderCell>Actual Hours</TableHeaderCell>
                  <TableHeaderCell>Efficiency Hours</TableHeaderCell>
                  <TableHeaderCell>Date Of Floor</TableHeaderCell>
                  <TableHeaderCell>Current</TableHeaderCell>
                  <TableHeaderCell>Tenure</TableHeaderCell>
                  <TableHeaderCell>Efficency</TableHeaderCell>
                  <TableHeaderCell>Estimate Hour</TableHeaderCell>
                  <TableHeaderCell>Total Framess</TableHeaderCell>
                  <TableHeaderCell>Target</TableHeaderCell>
                  <TableHeaderCell>Actual Target</TableHeaderCell>
                  <TableHeaderCell>Productivity %</TableHeaderCell>
                  <TableHeaderCell>Rejected Frames</TableHeaderCell>
                  <TableHeaderCell>Quality %</TableHeaderCell>
                  <TableHeaderCell>Artifacts Frames</TableHeaderCell>
                  <TableHeaderCell>Artifacts %</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
              {loadProjectData.length === 0 &&  loading === false && (
                                <Table.Row>
                                  <Table.Cell colSpan={18} textAlign="center">
                                    Currently Data not Avaialabe
                                  </Table.Cell>
                                </Table.Row>
              )}
              { loading === true  && (
                <Table.Row>
                                  <Table.Cell colSpan={18} textAlign="center">
                                  <Loader active inline='centered' > Please wait, this will take a few minutes... </Loader>
                                  </Table.Cell>
                                </Table.Row>
              )}
              {
                loadProjectData.map((data, index) => (
                <TableRow key={index}>
                  <TableCell>{data.employee_Id}</TableCell>
                  <TableCell>{data.employee_Name}</TableCell>
                  <TableCell>{data.project_Name}</TableCell>
                  <TableCell>{data.approval_Frames}</TableCell>
                  <TableCell>{data.total_Hours}</TableCell>
                  <Table.Cell>{data.efficiency_Hours}</Table.Cell>
                  <TableCell>{data.dof}</TableCell>
                  <TableCell>{data.current}</TableCell>
                  <TableCell>{data.tenure}</TableCell>
                  <TableCell>{data.efficency}</TableCell>
                  <TableCell>{data.est_Hour}</TableCell>
                  <TableCell>{data.total_Framess}</TableCell>
                  <TableCell>{data.target}</TableCell>
                  <TableCell>{data.actualTarget}</TableCell>
                  <TableCell>{data.productivity_percentage}</TableCell>
                  <TableCell>{data.sum_of_Rejected_Frames}</TableCell>
                  <TableCell>{data.quality_percentage}</TableCell>
                  <TableCell>{data.artifacts_Rejected_Frames}</TableCell>
                  <TableCell>{data.artifacts_Rejection_percentage}</TableCell>
                </TableRow>
              ))}
              </TableBody>
            </Table>
          </div> : 
          <div>
                  <Table  className='celled padded'>
                  <TableHeader style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                    <TableRow>
                      <TableHeaderCell>Emp ID</TableHeaderCell>
                      <TableHeaderCell>Emp Name</TableHeaderCell>
                      <TableHeaderCell>Designation</TableHeaderCell>
                      <TableHeaderCell>Team</TableHeaderCell>
                      <TableHeaderCell>Cluster Lead</TableHeaderCell>
                      <TableHeaderCell>Sum of Frames</TableHeaderCell>
                      <TableHeaderCell>Sum of Act Target</TableHeaderCell>
                      <TableHeaderCell>Sum of Reject Frame</TableHeaderCell>
                      <TableHeaderCell>Artifacts Rejected Frames</TableHeaderCell>
                      <TableHeaderCell>Productivity</TableHeaderCell>
                      <TableHeaderCell>Quality Percentage</TableHeaderCell>
                      <TableHeaderCell>Artifacts Rejected Frames Percentage</TableHeaderCell>
                      <TableHeaderCell>Working Days</TableHeaderCell>
                      <TableHeaderCell>Present Days</TableHeaderCell>
                      <TableHeaderCell>Leaves</TableHeaderCell>
                      <TableHeaderCell>Attendance Percentage</TableHeaderCell>
                      <TableHeaderCell>Tenure</TableHeaderCell>
                      <TableHeaderCell>Months</TableHeaderCell>
                      <TableHeaderCell>Efficency</TableHeaderCell>
                      <TableHeaderCell>Attendance Hours</TableHeaderCell>
                      <TableHeaderCell>HC Hours</TableHeaderCell>
                      <TableHeaderCell>HC Adherence</TableHeaderCell>
                      <TableHeaderCell>Scorecard</TableHeaderCell>
                      <TableHeaderCell>Rank</TableHeaderCell>
                      <TableHeaderCell>Points</TableHeaderCell>
                    </TableRow>
                  </TableHeader>
              <TableBody>
              {loadData.length === 0 && loading === false && (
                                <Table.Row>
                                  <Table.Cell colSpan={25} textAlign="center">
                                    Currently Data not Avaialabe
                                  </Table.Cell>
                                </Table.Row>
                              )}
            {loading === true && (
                                <Table.Row>
                                  <Table.Cell colSpan={25} textAlign="center">
                                  <Loader active inline='centered' > Please wait, this will take a few minutes... </Loader>
                                  </Table.Cell>
                                </Table.Row>
                              )}
            {loadData.map((item, index) => (
                                      <TableRow key={index}>
                                          <TableCell>{item.emp_ID}</TableCell>
                                          <TableCell>{item.emp_Name}</TableCell>
                                          <TableCell>{item.designation}</TableCell>
                                          <TableCell>{item.team}</TableCell>
                                          <TableCell>{item.cluster_Lead}</TableCell>
                                          <TableCell>{item.sum_of_Frames}</TableCell>
                                          <TableCell>{item.sum_of_Act_Target}</TableCell>
                                          <TableCell>{item.sum_of_Reject_Frame}</TableCell>
                                          <TableCell>{item.artifacts_Rejected_Frames}</TableCell>
                                          <TableCell>{item.productivity}</TableCell>
                                          <TableCell>{item.quality_Percentage}</TableCell>
                                          <TableCell>{item.artifacts_Rejected_Frames_Percentage}</TableCell>
                                          <TableCell>{item.working_Days}</TableCell>
                                          <TableCell>{item.present_Days}</TableCell>
                                          <TableCell>{item.leaves}</TableCell>
                                          <TableCell>{item.attendance_Percentage}</TableCell>
                                          <TableCell>{item.tenure}</TableCell>
                                          <TableCell>{item.months}</TableCell>
                                          <TableCell>{item.efficency}</TableCell>
                                          <TableCell>{item.attendance_Hours}</TableCell>
                                          <TableCell>{item.hC_Hours}</TableCell>
                                          <TableCell>{item.hC_Adherence}</TableCell>
                                          <TableCell>{item.scorecard}</TableCell>
                                          <TableCell>{item.rank}</TableCell>
                                          <TableCell>{item.points}</TableCell>
                                      </TableRow>
                                  ))}
                              </TableBody>
                  </Table>
          </div> 
  }
          </div>
          </div>
      </>
    )
}

export default MonthlyProductivityReport